import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/Routes.js';
import './theme/global.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
